import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { SharedService } from './shared/services/shared.service';
import { GlobalService } from './shared/services/global.service';

import { HTML2TXTPipe } from './shared/pipe/common.pipe';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// import { RecaptchaModule } from 'ng-recaptcha-2';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { AuthInterceptor } from './common/http.service'

@NgModule({ declarations: [
        AppComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: httpTranslateLoader,
                deps: [HttpClient]
            }
        }),
        BrowserAnimationsModule,
        // RecaptchaModule,
        MatProgressSpinnerModule], providers: [
        SharedService,
        GlobalService,
        HTML2TXTPipe,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }

// AOT compilation support
export function httpTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http);
}
